module.exports = __webpack_public_path__ + "img/icon-s3.e89c1a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/web/signStatistics/icon-s3.png
// module id = cZkL
// module chunks = 0 4 5 9